import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft, MapPin } from 'lucide-react';
import { useApp } from '../context/AppContext';
import { fetchAreas } from '../api';
import ProjectCard from '../components/ProjectCard';
import AreaMap from '../components/AreaMap';

const AreaDetail = () => {
  const { name } = useParams();
  const areaName = decodeURIComponent(name || '');
  const { t, projects } = useApp();
  const [meta, setMeta] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = `${areaName} \u2013 New Projects | GOBRA Capital Real Estate`;
    fetchAreas().then((list) => setMeta(list.find((a) => a.name === areaName) || null)).catch(() => {});
  }, [areaName]);

  const list = projects.filter((p) => p.area === areaName);

  return (
    <main className="pt-24 md:pt-28">
      <section className="relative h-[42vh] min-h-[320px] overflow-hidden">
        <img src={meta?.image || list[0]?.image} alt={areaName} className="h-full w-full object-cover" />
        <div className="absolute inset-0 gobra-hero-overlay" />
        <div className="absolute inset-0 flex flex-col justify-end max-w-[1400px] mx-auto px-4 md:px-8 pb-10">
          <Link to="/areas" className="inline-flex items-center gap-1.5 text-sm text-white/80 hover:text-white mb-3 w-fit">
            <ArrowLeft className="h-4 w-4" /> All Areas
          </Link>
          <div className="inline-flex items-center gap-1.5 text-gobra-orange text-sm font-semibold">
            <MapPin className="h-4 w-4" /> Dubai
          </div>
          <h1 className="font-title text-4xl md:text-6xl font-bold text-white">{areaName}</h1>
          {meta?.blurb && <p className="text-white/85 mt-3 max-w-2xl">{meta.blurb}</p>}
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-4 md:px-8 py-12 md:py-16">
        <h2 className="font-title text-2xl md:text-3xl font-bold text-gobra-slate mb-8">
          {list.length} {list.length === 1 ? 'Project' : 'Projects'} in {areaName}
        </h2>
        {list.length === 0 ? (
          <p className="text-muted-foreground">No projects listed in this area yet.</p>
        ) : (
          <>
            <div className="mb-10" data-testid="area-map-section">
              <AreaMap areaName={areaName} projects={list} />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 md:gap-6">
              {list.map((p) => <ProjectCard key={p.id} project={p} />)}
            </div>
          </>
        )}
      </section>
    </main>
  );
};

export default AreaDetail;
